<template>
  <div class="row justify-content-center">
    <div class="tit text-center">
      <h1>Edite sua informação pessoal</h1>
      <p>Olá {{firstName}}, para que você se torne um investidor, precisamos primeiramente que preencha as informaçõs abaixo:</p>
    </div>
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="text-center">
        <h2>Informações pessoais</h2>
      </div> 
      <form id="form-cadastro-investidor" @submit.prevent="submit">
        <div class="form-row">
          <div class="form-group col-12 col-md-12">
            <label>E-mail</label>
            <input v-model="email" name="email" class="form-control form-control-lg" type="text" required placeholder="E-mail" disabled/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-9">
            <label for="nome">Nome Completo *</label>
            <input tabindex="1" name="firstname" v-model="fullName" id="nome" v-bind:style="[ fullNameError ? { 'border-color': 'red'} : { 'border-color': 'none' } ]" @keyup="validateFullName()" class="form-control form-control-lg" type="text" required placeholder="Nome Completo"/>
          </div>
          <div class="form-group col-12 col-md-3">
            <label>Sexo *</label>
            <at-select tabindex="2" ref="sexSelect" name="gender" class="focus-select" v-model="sex" placeholder="Selecione" size="large">
              <at-option v-for="(sex, i) in sexOptions" :key="`sexOptions${i}`" :value="sex.value">{{sex.label}}</at-option>
            </at-select>
          </div>  
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-4">
            <label>Estado civil *</label>
            <at-select tabindex="3" ref="maritalSelect" class="focus-select" v-model="maritalStatus" placeholder="Selecione" size="large" required="true">
              <at-option v-for="(maritalStatus, i) in maritalStatusOptions" :key="`maritalStatusOptions${i}`" :value="maritalStatus.value" v-bind:selected="i === 0">{{maritalStatus.label}}</at-option>
            </at-select>
          </div> 
          <div class="form-group col-12 col-md-4">
            <label for="nomeMae">Nome da mãe *</label>
            <input tabindex="4" v-model="mothersName" @keyup="validateMothersName()" id="nomeMae" class="form-control form-control-lg" type="text" required placeholder="Nome da mãe"/>
          </div>
          <div class="form-group col-12 col-md-4">
            <label for="nomePai">Nome do pai *</label>
            <input tabindex="5" v-model="fathersName" id="nomePai" @keyup="validateFathersName()" class="form-control form-control-lg" type="text" required placeholder="Nome do pai"/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-6">
            <label>Telefone fixo</label>
            <input tabindex="6" name="phone" v-model="phoneNumber" class="form-control form-control-lg" type="text" placeholder="Telefone fixo" v-mask="'phone'"/>
          </div>
          <div class="form-group col-12 col-md-6">
            <label>Telefone celular *</label>
            <input tabindex="7" name="mobilephone" v-model="cellphoneNumber" class="form-control form-control-lg" type="text" required placeholder="Telefone celular" v-mask="'phone'"/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-6">
            <label for="cpf">CPF *</label>
            <input tabindex="8" v-model="cpf" id="cpf" class="form-control form-control-lg" type="text" required placeholder="CPF" v-mask="'cpf'"/>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="nacionalidade">Nacionalidade *</label>
            <at-select tabindex="9" ref="nationalitySelect" class="focus-select" v-model="nationality" placeholder="Selecione" size="large" required="true">
              <at-option v-for="(nationality, i) in nationalityOptions" :key="`nationalityOptions${i}`" :value="nationality.value">{{nationality.label}}</at-option>
            </at-select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-4">
            <label for="naturalidade">Estado onde nasceu *</label>
            <at-select tabindex="10" ref="placeOfBirthSelect" class="focus-select" id="naturalidade" v-model="placeOfBirth" size="large" filterable placeholder="Selecione">
              <at-option value="">Selecione</at-option>
              <at-option value="Exterior">--Exterior--</at-option>
              <at-option v-for="(state, i) in birthStatesOptions" :key="`birthStatesOptions${i}`" :value="state.nome">{{state.nome}}</at-option>
            </at-select>
          </div>
          <div class="form-group col-12 col-md-4">
            <label for="naturalidadeCidade">
              Cidade onde nasceu *
            </label>
            <input tabindex="11" v-model="cityOfBirth" id="cityOfBirth" @keyup="validateBornCity()" type="text" class="form-control form-control-lg" required placeholder="Cidade onde Nasceu"/>
          </div>
          <div class="form-group col-12 col-md-4">
            <label for="dataNascimento">Data de Nascimento *</label>
            <input tabindex="12" v-model="birthDate" class="form-control form-control-lg" format="dd/MM/yyyy" type="text" v-mask="'date'" required placeholder="dd/mm/aaaa"/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-12 col-md-3">
            <label for="rg">RG / RNE *</label>
            <input tabindex="13" v-model="rgNumber" @keyup="validateRgNumber()" id="rg" class="form-control form-control-lg" type="text" required placeholder="RG" v-mask="'rg'"/>
          </div>
          <div class="form-group col-12 col-md-3">
            <label for="orgao-emissor">Orgão emissor *</label>
            <input tabindex="14" v-model="rgIssuer" @keyup="validateRgIssuer()" id="orgao-emissor" class="form-control form-control-lg" type="text" required placeholder="Orgão emissor"/>
          </div>
          <div class="form-group col-12 col-md-3">
            <label for="rg-issuer-state">Estado Emissor *</label>
            <at-select tabindex="15" ref="rgIssuerStateSelect" class="focus-select" id="rg-issuer-state"  v-model="rgIssuerState" v-on:click="rgIssuerStateClear()" filterable size="large" placeholder="Selecione">
              <at-option value="">Selecione</at-option>
              <at-option v-for="(state, i) in states" :key="`stateOptions${i}`" :value="state.uf">{{state.uf}}</at-option>
            </at-select>
          </div>
          <div class="form-group col-12 col-md-3">
            <label for="data-emissao">Data de emissão *</label>
            <input tabindex="16" v-model="rgIssueDate" id="data-emissao" class="form-control form-control-lg" format="dd/MM/yyyy" type="text" v-mask="'date'" required placeholder="dd/mm/aaaa"/>
          </div>
        </div>
        <div class="text-center fixedOptions">
          <button class="btn btn-lg btn-primary">Próximo <img src="static/assets/images/angle-right.svg"></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Masker from '@/utils/masker'
  import HubConsultaClient from '@/utils/hub-consulta-client'

  export default {
    data() {
      
      const investor = this.investor;

      return {
        fullNameError: false,
        email: investor.Email,
        fullName: investor.NomeCompleto,
        sex: investor.Sexo,
        maritalStatus: investor.EstadoCivil,
        mothersName: investor.NomeMae,
        fathersName: investor.NomePai,
        phoneNumber: investor.TelefoneFixo || "",
        cellphoneNumber: investor.Celular,
        cpf: investor.Cpf,
        nationality: investor.Nacionalidade,
        placeOfBirth: investor.Naturalidade,
        cityOfBirth: investor.NaturalidadeCidade,
        birthDate: investor.DataNascimento ? investor.DataNascimento.toLocaleDateString('pt-BR') : null,
        rgNumber: investor.RgNumero,
        rgIssuer: investor.RgOrgaoEmissor,
        rgIssuerState: investor.RgEstadoEmissor,
        rgIssueDate: investor.RgDataEmissao ? investor.RgDataEmissao.toLocaleDateString('pt-BR') : null,

        sexOptions: [
          {value: "", label: "Selecione"}, 
          {value: 1, label: "Masculino"}, 
          {value: 2, label: "Feminino"}
        ],
        nationalityOptions: [
          {value: "", label: "Selecione"},
          {value: 1, label: "Brasileiro(a) Nato(a)"},
          {value: 2, label: "Brasileiro(a) Naturalizado(a)"},
          {value: 3, label: "Estrangeiro(a)"},
        ],
        maritalStatusOptions: [
          {value: "", label: "Selecione"},
          {value: 1, label: "Solteiro(a)"},
          {value: 2, label: "Casado(a)"},
          {value: 3, label: "Divorciado(a)"},
          {value: 4, label: "Viúvo(a)"}
        ],
        birthStatesOptions: [],
        states: [],
        firstName: investor.NomeCompleto.split(' ')[0],
      }
    },
    props: {
      investor: {type: Object, required: true}
    },
    methods: {
      validateRgNumber() {
        if(this.rgNumber[0] == " ") {
          this.rgNumber = "";
          return;
        } 
      },
      validateRgIssuer() {
        if(this.rgIssuer[0] == " ") {
          this.rgIssuer = "";
          return;
        } 
      },
      validateFullName() {
        if(this.fullName[0] == " ") {
          this.fullName = "";
          return;
        } 
        
        var splitText = this.fullName.split(' ');
        var upperCaseText = '';

        for(var i = 0; i < splitText.length; i++) {
          if(splitText[i] != "") {
             if(i > 0)
              upperCaseText += " ";

            upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
          }
          else if(i > 0)
            upperCaseText += " ";
        }

        this.fullName = upperCaseText;
      },
      validateFathersName() {
        if(this.fathersName[0] == " ") {
          this.fathersName = "";
          return;
        } 
        
        var splitText = this.fathersName.split(' ');
        var upperCaseText = '';

        for(var i = 0; i < splitText.length; i++) {
          if(splitText[i] != "") {
             if(i > 0)
              upperCaseText += " ";

            upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
          }
          else if(i > 0)
            upperCaseText += " ";
        }

        this.fathersName = upperCaseText;
      },
      validateMothersName() {
        if(this.mothersName[0] == " ") {
          this.mothersName = "";
          return;
        } 
        
        var splitText = this.mothersName.split(' ');
        var upperCaseText = '';

        for(var i = 0; i < splitText.length; i++) {
          if(splitText[i] != "") {
             if(i > 0)
              upperCaseText += " ";

            upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
          }
          else if(i > 0)
            upperCaseText += " ";
        }

        this.mothersName = upperCaseText;
      },
      validateBornCity() {
        if(this.cityOfBirth[0] == " ") {
          this.cityOfBirth = "";
          return;
        } 
        
        var splitText = this.cityOfBirth.split(' ');
        var upperCaseText = '';

        for(var i = 0; i < splitText.length; i++) {
          if(splitText[i] != "") {
             if(i > 0)
              upperCaseText += " ";

            upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
          }
          else if(i > 0)
            upperCaseText += " ";
        }

        this.cityOfBirth = upperCaseText;
      },
      validationNames() {
        var splited = this.clearSplitNames(this.fullName.split(" "));
        
        if(splited.length <= 1) {
          this.$Notify.error("Preencha o seu nome completo.");
          //this.fullNameError = true;
          return false;
        }

        return true;
      },
      clearSplitNames(splitName) {
        var cleanSplit = new Array();

        for(var i = 0; i < splitName.length; i++) {
          if(splitName[i] != "")
            cleanSplit.push(splitName[i])
        }

        return cleanSplit;
      },
      submit() {
        if(!this.validationNames())
          return;

        if(!this.isValidDate(this.birthDate)) {
          this.$Notify.error("A data de nascimento especificada é inválida.");
          return 
        }

        if(!this.isValidDate(this.rgIssueDate)) {
          this.$Notify.error("A data de emissão do RG especificada é inválida.");
          return 
        }

        if(this.sex === "") {
          this.$Notify.error("O campo sexo deve ser preenchido!");
          return 
        }

        if(this.maritalStatus === "") {
          this.$Notify.error("O campo estado civil deve ser preenchido!");
          return 
        }

        if(this.nationality === "") {
          this.$Notify.error("O campo nascionalidade deve ser preenchido!");
          return 
        }  


        if(this.rgIssuerState != "" && this.sex != "" && this.maritalStatus != "" && this.nationality != "") {

          this.$emit('submit', {
            Email: this.email,
            NomeCompleto: this.fullName,
            Sexo: this.sex,
            EstadoCivil: this.maritalStatus,
            NomeMae: this.mothersName,
            NomePai: this.fathersName,
            TelefoneFixo: this.phoneNumber.length > 0 ? this.phoneNumber : null,
            Celular: this.cellphoneNumber,
            Cpf: Masker.unmaskCpf(this.cpf),
            Nacionalidade: this.nationality,
            Naturalidade: this.placeOfBirth,
            NaturalidadeCidade: this.cityOfBirth,
            DataNascimento: this.birthDate,
            RgNumero: Masker.unmaskRg(this.rgNumber),
            RgOrgaoEmissor: this.rgIssuer,
            RgEstadoEmissor: this.rgIssuerState,
            RgDataEmissao: this.rgIssueDate
          });
        }
        
      },
      isValidDate(dateString) {
        var splittedDate = dateString.split("/");

        if(splittedDate.length == 3) {
          var day = parseInt(splittedDate[0]);
          var month = parseInt(splittedDate[1] - 1);
          var year = parseInt(splittedDate[2]);

          if(year <= 1900) return false;

          var dt = new Date(year, month, day);

          return dt.getMonth() == month && dt.getDate() == day && dt.getUTCFullYear() == year
        }

        return false;
      }
    },
    created() {
      HubConsultaClient.pegarEstados()
        .then(states => {
          this.states = states
          this.birthStatesOptions = states
          const rgIssuerState = this.rgIssuerState
          const placeOfBirth = this.placeOfBirth
          this.rgIssuerState = ''
          this.placeOfBirth = ''

          setTimeout(() => {
            this.rgIssuerState = rgIssuerState
            this.placeOfBirth = placeOfBirth
          }, 100)
        })
    },
    mounted() {
      this.$refs.sexSelect.$el.children[0].children[2].required = true;
      this.$refs.rgIssuerStateSelect.$el.children[0].children[2].required = true;
      this.$refs.maritalSelect.$el.children[0].children[2].required = true;
      this.$refs.nationalitySelect.$el.children[0].children[2].required = true;
      this.$refs.placeOfBirthSelect.$el.children[0].children[2].required = true;     
      
      if(this.sex == null)
        this.$refs.sexSelect.selectFirstOption();

      if(this.rgIssuerState == null)
        this.$refs.rgIssuerStateSelect.selectFirstOption();
      
      if (this.maritalStatus == null)
        this.$refs.maritalSelect.selectFirstOption();

      if(this.nationality == null)
        this.$refs.nationalitySelect.selectFirstOption()

      if(this.placeOfBirth == null)
        this.$refs.placeOfBirthSelect.selectFirstOption()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoInformacoesPessoais.vue